module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/home-mobile-application-b86d5443d062c686dfeb9e3009367343.png";